const CYCLES = [
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "annually", label: "Annually" },
];

function BillingCycleToggle({ value, onChange }) {
  return (
    <div className="flex h-9 p-0.5 bg-gray-100 border border-gray-200 rounded-lg">
      {CYCLES.map((cycle) => {
        const isActive = value === cycle.value;
        return (
          <button
            key={cycle.value}
            type="button"
            onClick={() => onChange(cycle.value)}
            className={`flex-1 rounded-md text-xs font-medium transition-all ${
              isActive
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {cycle.label}
          </button>
        );
      })}
    </div>
  );
}

export default BillingCycleToggle;